import { useMemo } from 'react'

import { LessonType, ProductDto, Skier } from '../../../service/types'

type BookingEntry = {
  customerId?: string
  skiers?: Skier[]
}

type Params = {
  products: ProductDto[]
  productId: string
  lessonType: LessonType
  skiers: Skier[]
  bookings: BookingEntry[]
}

type PricingResult = {
  skierPrices: number[]
  total: number
}

export function useLessonPricing({ products, productId, lessonType, skiers, bookings }: Params): PricingResult | null {
  return useMemo(() => {
    const product = products.find((p) => p.id === productId)
    if (!product) return null

    const allSkiers: Skier[] =
      lessonType === LessonType.Group ? (bookings ?? []).flatMap((b) => b.skiers ?? []) : (skiers ?? [])

    if (allSkiers.length === 0) return null

    const skierPrices = allSkiers.map((_, index) => {
      if (lessonType === LessonType.Private && index > 0) {
        return product.pricePerAdditionalPerson ?? product.price
      }
      return product.price
    })

    const total = skierPrices.reduce((sum, p) => sum + p, 0)

    return { skierPrices, total }
  }, [products, productId, lessonType, skiers, bookings])
}
